@if (toasts().length) {
  <div class="toast-container">
    @for (toast of toasts(); track $index) {
      <app-message [type]="toast.type">
        @if (toast.message.code) {
          <p [appI18n]="{ code: toast.message.code, default: toast.message.default }"></p>
        }
        @else {
          <p>{{ toast.message.default }}</p>
        }
        @if (!toast.duration) {
          <div class="toast-actions">
            <button type="button" class="btn btn-{{ toast.type }}" (click)="dismiss($index)">OK</button>
          </div>
        }
      </app-message>
    }
  </div>
}